// src/utils/helpers.js

/**
 * Shuffles an array using the Fisher-Yates (Knuth) algorithm.
 * Creates a shallow copy to avoid mutating the original array.
 * @param {Array} array The array to shuffle.
 * @returns {Array} A new, shuffled array.
 */
export const shuffleArray = (array) => {
    const newArray = [...array]; // Create a shallow copy
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
};
